var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49935 1.78125C7.26685 1.78125 5.2006 2.73917 3.75977 4.34625V2.375C3.75977 2.05042 3.4906 1.78125 3.16602 1.78125C2.84143 1.78125 2.57227 2.05042 2.57227 2.375V6.33333C2.57227 6.65792 2.84143 6.92708 3.16602 6.92708H7.12435C7.44893 6.92708 7.7181 6.65792 7.7181 6.33333C7.7181 6.00875 7.44893 5.73958 7.12435 5.73958H4.1556C5.36685 4.01375 7.34602 2.96875 9.49935 2.96875C13.1014 2.96875 16.0306 5.89792 16.0306 9.5C16.0306 9.82458 16.2998 10.0938 16.6243 10.0938C16.9489 10.0938 17.2181 9.82458 17.2181 9.5C17.2181 5.24083 13.7585 1.78125 9.49935 1.78125Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 12.0729H11.875C11.5504 12.0729 11.2812 12.3421 11.2812 12.6667C11.2812 12.9913 11.5504 13.2604 11.875 13.2604H14.8437C13.6325 14.9863 11.6533 16.0312 9.5 16.0312C5.89792 16.0312 2.96875 13.1021 2.96875 9.5C2.96875 9.17542 2.69958 8.90625 2.375 8.90625C2.05042 8.90625 1.78125 9.17542 1.78125 9.5C1.78125 13.7592 5.24083 17.2188 9.5 17.2188C11.7325 17.2188 13.7987 16.2608 15.2396 14.6538V16.625C15.2396 16.9496 15.5087 17.2188 15.8333 17.2188C16.1579 17.2188 16.4271 16.9496 16.4271 16.625V12.6667C16.4271 12.3421 16.1579 12.0729 15.8333 12.0729Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetFilters);
export default __webpack_public_path__ + "static/media/reset-filters.e98dabf0e296713ee521ba6898b855ef.svg";
export { ForwardRef as ReactComponent };